"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectManifoldEthereumProvider = void 0;
var frontend_provider_types_1 = require("@manifoldxyz/frontend-provider-types");
/**
 * Returns a Promise that resolves to the value of window.ManifoldEthereumProvider if it is
 * set within the given timeout, or null.
 * The Promise will not reject, but an error will be thrown if invalid options
 * are provided.
 *
 * @param options - Options bag.
 * @param options.silent - Whether to silence console errors. Does not affect
 * thrown errors. Default: false
 * @param options.timeout - Milliseconds to wait for 'ethereum#initialized' to
 * be dispatched. Default: 3000
 * @param options.initialized - Whether to check if the provider has already
 * been initialized. Default: true
 * @returns A Promise that resolves with the Provider if it is detected within
 * given timeout, otherwise null.
 */
function detectManifoldEthereumProvider(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.silent, silent = _c === void 0 ? false : _c, _d = _b.timeout, timeout = _d === void 0 ? 3000 : _d, _e = _b.initialized, initialized = _e === void 0 ? true : _e;
    _validateInputs();
    var handled = false;
    /**
     * Helper function to check if the provider has been initialized.
     */
    function providerInitialized() {
        var provider = window.ManifoldEthereumProvider;
        // Note: ._isInitialized is a property for older versions of the provider
        return ((!initialized && !!provider) || !!(provider === null || provider === void 0 ? void 0 : provider.initialized) || !!(provider === null || provider === void 0 ? void 0 : provider._isInitialized));
    }
    return new Promise(function (resolve) {
        if (providerInitialized()) {
            handleManifoldEthereum();
        }
        else {
            // Listen for provider via event
            window.addEventListener(frontend_provider_types_1.MANIFOLD_ETHEREUM_INITIALIZED, handleManifoldEthereum, {
                once: true,
            });
            if (!initialized) {
                window.addEventListener(frontend_provider_types_1.MANIFOLD_ETHEREUM_EXISTS, handleManifoldEthereum, {
                    once: true,
                });
            }
            // Poll for provider (legacy clients that do not emit event)
            var intervalId_1 = setInterval(function () {
                if (providerInitialized()) {
                    clearInterval(intervalId_1);
                    handleManifoldEthereum();
                }
            }, 100);
            // Timeout
            setTimeout(function () {
                clearInterval(intervalId_1);
                handleManifoldEthereum();
            }, timeout);
        }
        function handleManifoldEthereum() {
            // Already andled
            if (handled) {
                return;
            }
            handled = true;
            window.removeEventListener(frontend_provider_types_1.MANIFOLD_ETHEREUM_INITIALIZED, handleManifoldEthereum);
            if (!initialized) {
                window.removeEventListener(frontend_provider_types_1.MANIFOLD_ETHEREUM_EXISTS, handleManifoldEthereum);
            }
            if (providerInitialized()) {
                resolve(window.ManifoldEthereumProvider);
            }
            else {
                !silent &&
                    console.error('@manifoldxyz/frontend-provider-utils:', 'Unable to detect window.ManifoldEthereumProvider.');
                resolve(null);
            }
        }
    });
    function _validateInputs() {
        if (typeof silent !== 'boolean') {
            throw new Error("@manifoldxyz/frontend-provider-utils: Expected option 'silent' to be a boolean.");
        }
        if (typeof timeout !== 'number') {
            throw new Error("@manifoldxyz/frontend-provider-utils: Expected option 'timeout' to be a number.");
        }
    }
}
exports.detectManifoldEthereumProvider = detectManifoldEthereumProvider;
